import { useEffect, useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { useAuth } from '@/contexts/AuthContext'
import { pozisyonOlustur, pozisyonGuncelle } from '@/lib/services/pozisyon-service'
import type { Pozisyon } from '@/types'

interface PozisyonFormModalProps {
  acik: boolean
  pozisyon: Pozisyon | null
  onKapat: () => void
  onKaydedildi: () => void
}

export function PozisyonFormModal({ acik, pozisyon, onKapat, onKaydedildi }: PozisyonFormModalProps) {
  const { firebaseUser } = useAuth()
  const [isim, setIsim] = useState('')
  const [hata, setHata] = useState<string | null>(null)
  const [isimHata, setIsimHata] = useState<string | null>(null)
  const [kaydediliyor, setKaydediliyor] = useState(false)

  useEffect(() => {
    if (pozisyon) {
      setIsim(pozisyon.isim)
    } else {
      setIsim('')
    }
    setHata(null)
    setIsimHata(null)
  }, [pozisyon, acik])

  async function kaydet(ev: React.FormEvent) {
    ev.preventDefault()
    setHata(null)
    setIsimHata(null)

    if (!isim.trim()) {
      setIsimHata('Pozisyon adı zorunlu')
      return
    }
    if (!firebaseUser) {
      setHata('Oturum bulunamadı, lütfen tekrar giriş yapın.')
      return
    }

    setKaydediliyor(true)
    try {
      const data = { isim: isim.trim() }
      if (pozisyon) {
        await pozisyonGuncelle(pozisyon.id, data)
      } else {
        await pozisyonOlustur(data, firebaseUser.uid)
      }
      onKaydedildi()
    } catch (err) {
      setHata('Kaydedilemedi: ' + (err as Error).message)
    } finally {
      setKaydediliyor(false)
    }
  }

  return (
    <Modal
      acik={acik}
      onKapat={onKapat}
      baslik={pozisyon ? 'Pozisyonu Düzenle' : 'Yeni Pozisyon'}
    >
      <form onSubmit={kaydet} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Pozisyon Adı <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={isim}
            onChange={e => setIsim(e.target.value)}
            className="input-base"
            placeholder="Örn: Kasiyer, Rafçı..."
            disabled={kaydediliyor}
            autoFocus
          />
          {isimHata && <p className="text-xs text-red-600 mt-1">{isimHata}</p>}
        </div>

        {hata && (
          <div className="bg-red-50 border border-red-200 text-red-800 text-sm rounded-xl p-3">
            {hata}
          </div>
        )}

        <div className="flex gap-2 pt-2">
          <button
            type="button"
            onClick={onKapat}
            className="btn-secondary flex-1"
            disabled={kaydediliyor}
          >
            İptal
          </button>
          <button type="submit" className="btn-primary flex-1" disabled={kaydediliyor}>
            {kaydediliyor ? 'Kaydediliyor...' : pozisyon ? 'Güncelle' : 'Ekle'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
